import ashoka from "./stage10/cards/AshokaLionCapital.png";
import konark from "./stage10/cards/KonarkWheel.png";
import dancingGirl from "./stage10/cards/DancingGirl.png";
import harappanSeal from "./stage10/cards/HarappanSeal.png";
import nataraja from "./stage10/cards/natraj.png";
import sanchi from "./stage10/cards/SanchiStupa.png";
import indiaGate from "./stage10/cards/IndiaGate.png";
import constitution from "./stage10/cards/ConstitutionofIndia.png";
import redFort from "./stage10/cards/redfort.png";
import charminar from "./stage10/cards/Charminar.png";
import gateway from "./stage10/cards/GatewayofIndia.png";
import hawaMahal from "./stage10/cards/hawamahal.png";
import cardBack from "./stage10/cards/back.png";
import cardFront from "./stage10/cards/front.png";
import lockedKey from "./stage10/cards/key.png";
import heritageSeal from "./stage10/cards/heritagesealbadge.png";

/** Points written to DB `stage10` on successful restore. */
export const MEMORY_WALL_POINTS = 100;

export const GAME_COMPLETE_KEY = "restore_legacy_complete";
export const HALL2_COMPLETE_KEY = "hall2_complete";

export const MEMORY_SUCCESS_COPY = {
  title: "Heritage Seal restored!",
  body: "The Hall of Heritage is complete.",
  sealCaption:
    "You have collected all matching pairs and unlocked the Heritage Seal.",
};

export const MEMORY_ASSETS = {
  back: cardBack,
  front: cardFront,
  locked: lockedKey,
  seal: heritageSeal,
};

/** 12 image↔name pairs for the Memory Wall. */
export const MEMORY_PAIRS = [
  { id: "ashoka", name: "Ashoka Lion Capital", image: ashoka },
  { id: "konark", name: "Konark Wheel", image: konark },
  { id: "dancing_girl", name: "Dancing Girl", image: dancingGirl },
  { id: "harappan_seal", name: "Harappan Seal", image: harappanSeal },
  { id: "nataraja", name: "Nataraja", image: nataraja },
  { id: "sanchi", name: "Sanchi Stupa", image: sanchi },
  { id: "india_gate", name: "India Gate", image: indiaGate },
  { id: "constitution", name: "Constitution of India", image: constitution },
  { id: "red_fort", name: "Red Fort", image: redFort },
  { id: "charminar", name: "Charminar", image: charminar },
  { id: "gateway", name: "Gateway of India", image: gateway },
  { id: "hawa_mahal", name: "Hawa Mahal", image: hawaMahal },
];

export const GRID_SIZE = 5;

export function shuffleArray(items) {
  const next = [...items];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
}

/**
 * Build 25 shuffled tiles: 24 pair tiles + 1 key/seal tile (random position).
 * @returns {{ tiles: Array, keyIndex: number }}
 */
export function buildMemoryDeck(pairs = MEMORY_PAIRS) {
  const playable = [];
  pairs.forEach((pair) => {
    playable.push({
      id: `${pair.id}-image`,
      pairId: pair.id,
      kind: "image",
      name: pair.name,
      image: pair.image,
    });
    playable.push({
      id: `${pair.id}-name`,
      pairId: pair.id,
      kind: "name",
      name: pair.name,
      image: null,
    });
  });

  playable.push({
    id: "heritage-key",
    pairId: null,
    kind: "key",
    name: "Heritage Seal",
    image: null,
  });

  const tiles = shuffleArray(playable);
  const keyIndex = tiles.findIndex((t) => t.kind === "key");
  return { tiles, keyIndex };
}

export function markHallOfHeritageComplete() {
  sessionStorage.setItem(HALL2_COMPLETE_KEY, "1");
  sessionStorage.setItem(GAME_COMPLETE_KEY, "1");
}

export function isGameComplete() {
  return sessionStorage.getItem(GAME_COMPLETE_KEY) === "1";
}

/** Session payload for the final / thank-you screens. */
export function prepareEndGameData({ elapsedSec, stage10Score }) {
  const payload = {
    completedAt: Date.now(),
    elapsedSec: Number(elapsedSec) || 0,
    stage10Score: Number(stage10Score) || MEMORY_WALL_POINTS,
    hall: "heritage",
    gameComplete: true,
  };
  try {
    sessionStorage.setItem("end_game_data", JSON.stringify(payload));
  } catch {
    /* ignore */
  }
  return payload;
}

export function readEndGameData() {
  try {
    const raw = sessionStorage.getItem("end_game_data");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
